"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isUUIDv4 = exports.isStringOfLength = exports.isString = void 0;
var _common = require("../../config/common");
var _isDefined = require("../misc-checks/isDefined");
var _isOfLength = require("../misc-checks/isOfLength");
/**
 * Tests if argument is a string
 *
 * @name isString
 * @param {argument} Argument to test
 * @returns {boolean} Result of string tests
 */
const isString = targetString => {
  return (0, _isDefined.isDefined)(targetString) && typeof targetString === "string";
};

/**
 * Tests if argument is a string of length
 *
 * @name isStringOfLength
 * @param {argument} Argument to test
 * @returns {boolean} Result of string and string length tests
 */
exports.isString = isString;
const isStringOfLength = targetString => {
  return isString(targetString) && (0, _isOfLength.isOfLength)(targetString.trim());
};

/**
 * Tests if argument is an object
 *
 * @name isUUIDv4
 * @param {string} String to test
 * @returns {boolean} Result of comparing to UUIDv4 format
 */
exports.isStringOfLength = isStringOfLength;
const isUUIDv4 = targetString => {
  return isStringOfLength(targetString) && new RegExp(_common.EXP_UUIDV4).test(targetString);
};
exports.isUUIDv4 = isUUIDv4;